// ✅ FIXED: Correct import path
import { UserTypeSelection } from '../components/Auth-Designer/UserTypeSelection';

const UserTypeSelectionPage = () => {
  return (
    <main>
      <UserTypeSelection />
    </main>
  );
};

export default UserTypeSelectionPage;